import React from 'react'
import moment from 'moment'
import { formatTwoDigitValue } from '../../../../helper/common'
import { OPTIONS_VEHICLE_TYPE_INFO_VEHICLE } from '../../../../constants/vehicle'
import resultHasViolationImage from '../../../../assets/images/result_has_violation.png'
import resultNoViolationImage from '../../../../assets/images/result_no_violation.png'
import SafeImage from '../../../../components/BasicComponent/SafeImage'
import './index.scss'

function getVehicleTypeLabel(vehicleType) {
  return (
    OPTIONS_VEHICLE_TYPE_INFO_VEHICLE.find((item) => Number(item.vehicleType ?? item.value) === Number(vehicleType))?.label || ''
  )
}

export default function ResultCriminalCard({ isVehicleWarning = 0, checkedAt, vehicleType, vehicleIdentity = '', criminalCount = 0 }) {
  const hasCriminal = String(isVehicleWarning) === '1' || isVehicleWarning === 1 || isVehicleWarning === true
  const checkedAtText = moment(checkedAt || new Date()).format('HH:mm, DD/MM/YYYY')
  const heroImage = hasCriminal ? resultHasViolationImage : resultNoViolationImage
  const criminalCountNumber = Number(criminalCount)
  const criminalCountText = formatTwoDigitValue(Number.isFinite(criminalCountNumber) ? Math.max(0, criminalCountNumber) : null, '00')
  const vehicleTypeLabel = getVehicleTypeLabel(vehicleType)

  return (
    <div className="ResultCriminalCard">
      <div className="ResultCriminalCard_center">
        <div className="ResultCriminalCard_imageWrap">
          <SafeImage className="ResultCriminalCard_image" src={heroImage} />
          <div className={`ResultCriminalCard_plate ${hasCriminal ? 'ResultCriminalCard_plate_warning' : 'ResultCriminalCard_plate_success'}`}>
            {/* {vehicleTypeLabel ? <div className="ResultCriminalCard_plate_vehicleType">{vehicleTypeLabel}</div> : null} */}
            <span>{String(vehicleIdentity || '').toUpperCase()}</span>
          </div>
        </div>

        <div className={`ResultCriminalCard_title`}>
          {hasCriminal ? (
            <>
              Phát hiện xe có <span className="ResultCriminalCard_titleCount">{criminalCountText}</span> lỗi vi phạm
            </>
          ) : (
            <>
              Xe của bạn sạch như bảng điểm 10,
              không có lỗi phạt nguội nào!
            </>
          )}
        </div>

        <div className="ResultCriminalCard_checkedAt">Tra cứu lúc {checkedAtText}</div>
      </div>
    </div>
  )
}

